/**
 * Shared inline-style helpers ported from the Claude Design handoff. Keeps
 * the components below short and visually consistent.
 */
import type { CSSProperties } from "react";

export const cardStyle: CSSProperties = {
  background: "rgba(16,18,27,.72)",
  border: "1px solid rgba(255,255,255,.06)",
  borderRadius: 18,
  padding: 24,
  backdropFilter: "blur(12px)",
};

export const inputStyle: CSSProperties = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,.10)",
  background: "rgba(17,24,39,.5)",
  color: "var(--ql-fg)",
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

export const monoInputStyle: CSSProperties = {
  ...inputStyle,
  fontFamily: "var(--ql-font-mono)",
  letterSpacing: "0.02em",
};

export const ctaBtnStyle = (enabled: boolean): CSSProperties => ({
  padding: "14px 28px",
  borderRadius: 16,
  fontWeight: 700,
  fontSize: 15,
  cursor: enabled ? "pointer" : "not-allowed",
  fontFamily: "inherit",
  border: "none",
  color: enabled ? "#000" : "var(--ql-fg-subtle)",
  background: enabled ? "linear-gradient(135deg,#FFD500,#FFA500)" : "rgba(255,255,255,.04)",
  boxShadow: enabled ? "0 4px 16px rgba(255,213,0,.30)" : "none",
  display: "inline-flex",
  alignItems: "center",
  gap: 10,
  transition: "all .2s var(--ql-ease)",
});

export const ctaSmallStyle: CSSProperties = {
  padding: "10px 18px",
  borderRadius: 12,
  fontWeight: 700,
  fontSize: 13,
  cursor: "pointer",
  fontFamily: "inherit",
  border: "none",
  color: "#000",
  background: "linear-gradient(135deg,#FFD500,#FFA500)",
  boxShadow: "0 4px 16px rgba(255,213,0,.25)",
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
};

/**
 * Quiet sibling of ctaSmallStyle for ROUTINE actions. The gradient bar is
 * reserved for the one primary action of a surface (Schedule post, submit a
 * job, commit a re-cut) — a wall of gradient bars has no hierarchy, which is
 * exactly what the Edit-clip panel looked like before this existed. Same
 * geometry as ctaSmallStyle so the two mix on one row without wobble.
 */
export const ctaGhostStyle: CSSProperties = {
  padding: "10px 18px",
  borderRadius: 12,
  fontWeight: 700,
  fontSize: 13,
  cursor: "pointer",
  fontFamily: "inherit",
  border: "1px solid rgba(255,213,0,.40)",
  color: "var(--ql-yellow)",
  background: "rgba(255,213,0,.06)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
};

export const iconBtnStyle: CSSProperties = {
  width: 36,
  height: 36,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,.08)",
  background: "rgba(255,255,255,.02)",
  color: "var(--ql-gray-300)",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "inherit",
};

export const fieldLabelStyle: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: "var(--ql-fg-muted)",
  marginBottom: 8,
  textTransform: "uppercase",
  letterSpacing: ".06em",
};
